export default {
  default: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/layouts/default.vue").then(m => m.default || m),
  error: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/layouts/error.vue").then(m => m.default || m)
}